import { Component, inject, Input, OnInit } from '@angular/core';
import { EventManager } from 'src/app/core';
import { Subscription } from 'rxjs';
import { FileUploader } from 'ng2-file-upload';
import { UploadFileService } from 'src/app/shared/services/upload-file.service';
import { ProductService } from '../../product.service';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { ToastrService } from 'ngx-toastr';
import { ModalComponent } from '../../../../shared/components/modal.component';
declare let $;
@Component({
  selector: 'app-update-nav-popup',
  templateUrl: './update-nav-popup.component.html',
  styleUrls: ['./update-nav-popup.component.scss']
})
export class UpdateNavPopupComponent extends ModalComponent implements OnInit {
  @Input() title: string = '';
  @Input() eventBroadcast: string = '';
  subscriptions?: Subscription[] = [];
  template: string = '';
  uploader: FileUploader;
  isSaved: boolean = false;
  file: any;
  fileName: string = '';
  list: any[] = [];
  readonly nzModalData: any = inject(NZ_MODAL_DATA);
  constructor(
    private productService: ProductService,
    public eventManager: EventManager,
    private modalRef : NzModalRef,
    private toastService: ToastrService
  ) {
    super(eventManager);
  }
  uploadFile(index?, item?) {
    $('#fileInput').val('');
    setTimeout(() => {
      $('#fileInput').click();
    }, 50)
  }
  selectFile(event) {
    const files = event.target.files;
    const result = UploadFileService.validate(files)
    if (!result) {
      return;
    }
    // this.isUpload = true;
    this.file = files[0];
    this.fileName = this.file.name;
    this.uploadFileNav();
  }
  uploadFileNav() {
    let formData = new FormData();
    formData.append("file", this.file);
    this.productService.uploadFileNAV(formData)
    .subscribe(
      (res: any) => {
        this.list = (res.body.data || []).map((item) => {
          if (item.percent <= 96 || item.percent >= 104) {
            item.isHighligt = true;
          }
          item.percentChange = item.percent - 100;
          return item;
        });
      },
      (error) => {
        const text = error && error.error ? error.error.message: '';
        this.toastService.error(text || 'Error Upload');
      },
    )
  }
  save() {
    const body = this.list;
    this.productService.createRequestUploadNAV(body)
    .subscribe(
      (res) => {
        this.toastService.success('Update NAV thành công!');
        this.cancel();
      },
      (error) => {
        const text = error && error.error ? error.error.message: '';
        this.toastService.error(text || 'Error Upload');
      },
    )
  }
  cancel() {
    this.modalRef.close();
    this.eventManager.broadcast({
      name: 'load-nav',
      content: {}
    });
  }
}
